import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { getApiBase } from "../apiBase";

export default function GeneratePrompts() {
  const { tenantId, botId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [botName, setBotName] = useState("");


  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 2500);
  };

  const fetchBotName = async () => {
  try {
    const res = await fetch(
      `${getApiBase()}/tenant/${tenantId}/bot/${botId}/details`
    );

    if (!res.ok) throw new Error("Failed to fetch bot name");

    const response = await res.json();

    setBotName(response?.data?.bot_name || "Your Bot");
  } catch (err) {
    console.error("Bot name fetch failed:", err);
    setBotName("Your Bot");
  }
};

  const handleGenerate = async () => {
  try {
    setLoading(true);
    showToast("Prompt generation started...");

    const res = await fetch(
      `${getApiBase()}/tenant/${tenantId}/bot/${botId}/generate-prompts`,
      { method: "POST" }
    );

    if (!res.ok) throw new Error("Failed");

    showToast("Prompt created successfully!");

    setTimeout(() => {
      navigate("/dashboard");
    }, 1800);

  } catch {
    showToast("❌ Prompt generation failed", "error");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (!tenantId || !botId) return;
  fetchBotName();
}, [tenantId, botId]);



  return (
    <div className="min-h-screen bg-white px-10 py-12">

      {toast && (
        <div
          className={`fixed top-5 right-5 px-5 py-2.5 rounded-md text-sm text-white shadow-md ${
            toast.type === "error" ? "bg-red-600" : "bg-green-600"
          }`}
        >
          {toast.msg}
        </div>
      )}

      <div className="max-w-5xl mx-auto">

        {/* Step Indicator */}
        <div className="flex items-center justify-between mb-10">
          <p className="text-sm font-semibold text-gray-700">
            Step <span className="text-gray-900">3</span> of 3
          </p>
          <div className="h-[3px] w-56 bg-gray-300 rounded-full overflow-hidden">
            <div className="h-full w-full bg-[#5B3A60]" />
          </div>
        </div>

        {/* Header */}
        <div className="border-b-2 pb-8 mb-14">
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
            Building {botName}’s Intelligence
          </h1>
          <p className="text-sm text-gray-600 mt-2 max-w-2xl leading-relaxed">
            Your setup is complete. We're now generating the intelligence that powers your conversational assistant.
          </p>
        </div>

        {/* Status Checklist */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20">

          <div className="border-l-4 border-[#5B3A60] pl-5">
            <p className="text-xs font-bold uppercase text-gray-500 mb-1">
              Industry, Voice and Personality
            </p>
            <p className="text-sm font-semibold text-gray-900 mb-1">
              Bot Identity Ready
            </p>
            <p className="text-xs text-gray-600 leading-relaxed">
              Industry, tone and behavioral style applied.
            </p>
          </div>

          <div className="border-l-4 border-[#5B3A60] pl-5">
            <p className="text-xs font-bold uppercase text-gray-500 mb-1">
              Knowledge Base
            </p>
            <p className="text-sm font-semibold text-gray-900 mb-1">
              Knowledge Processed
            </p>
            <p className="text-xs text-gray-600 leading-relaxed">
              Uploaded documents and scraped pages are processed.
            </p>
          </div>

          <div className="border-l-4 border-[#5B3A60] pl-5">
            <p className="text-xs font-bold uppercase text-gray-500 mb-1">
              System Prompts
            </p>
            <p className="text-sm font-semibold text-gray-900 mb-1">
              Intelligence Layer Ready
            </p>
            <p className="text-xs text-gray-600 leading-relaxed">
              Final instruction layer is created here.
            </p>
          </div>

        </div>

        {/* Activation Footer */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-t-2 pt-8 gap-6">

          <div>
            <p className="text-sm font-semibold text-gray-900 mb-1">
              What happens next?
            </p>
            <p className="text-xs text-gray-600 leading-relaxed max-w-md">
              Your bot will go live as soon as you activate it. You can test and manage it anytime from your Dashboard.
            </p>
          </div>

          <button
  onClick={handleGenerate}
  disabled={loading}
  className={`px-14 py-3 rounded-md text-sm font-bold tracking-wide flex items-center justify-center gap-2 transition ${
    loading
      ? "bg-gray-300 text-gray-600 cursor-not-allowed"
      : "bg-[#5B3A60] text-white hover:shadow-lg hover:opacity-95"
  }`}
>
  {loading ? (
    <>
      <span className="loader w-4 h-4 border-2 animate-spin"></span>
      Generating...
    </>
  ) : (
    "Generate Prompt"
  )}
</button>


        </div>

      </div>
    </div>
  );
}
